import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, failedResponse } from "../common";
import { getToken } from "../../features/user/UserAvatar";
import { PhotoFaceInfo } from "./photoFaceSlice";

export interface FaceSetNobodyState {
  state: LoadStateInfo;
  request?: SetFaceNobodyRequest;
}

const initialState: FaceSetNobodyState = {
  state: notStarted(),
};

export interface SetFaceNobodyRequest {
  face: PhotoFaceInfo;
}

export const requestSetFaceNobody = createAsyncThunk(
  "requestSetFaceNobody",
  async (param: SetFaceNobodyRequest, thunkAPI) => {
    console.debug("requestSetFaceNobody");

    const response = await fetch(`${getBackendUrl()}/api/face/${param.face.id}/nobody`, {
      method: "POST",
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
    });

    if(response.ok) {
      return await response.json();
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);


export const faceSetNobodySlice = createSlice({
  name: "faceSetNobody",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clean: (state) => {
      state.state = notStarted();
      state.request = undefined;
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(requestSetFaceNobody.pending, (state, /* action */) => {
        state.state =  loading();
      })
      .addCase(requestSetFaceNobody.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state =  loaded();
      })
      .addCase(requestSetFaceNobody.rejected, (state, action) => {
        state.state = error(action);
      });
    },
});

// export const { } = faceSetNobody.actions;

export const selectFaceSetNobody = (state: RootState) => state.faceSetNobody;

export default faceSetNobodySlice.reducer;
